import React, { useState } from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Box,
  Avatar,
  Paper,
  Fade,
  Button,
  IconButton,
  TextField,
} from "@mui/material";

import {
  WebOutlined,
  PhoneAndroid,
  Code,
  Build,
  AccessAlarm,
  CheckCircle,
  Settings,
  Facebook,
  Instagram,
  WhatsApp,
} from "@mui/icons-material";
import Navbar from "./Navbar";
import Language from "./Language";
import WorkShowcase, {
  BaPostPage,
  BahozPage,
  BardawamPage,
  BardawamPlusPage,
  CleverSchoolPage,
  FomsiPage,
  KarwanCompanyPage,
  Kts4uPage,
  LogoSlider,
  NoonPage,
  RainSeasonPage,
  RebazCarsPage,
  RestaurantMenuPage,
  SalvanoGroupPage,
  SamHomePage,
  SinoLoPage,
  TalabDeliveryPage,
  UkToMarsPage,
  WarehousePage,
} from "./WorkShowcase";

import "../App.css";

const CONTACT_EMAIL = "techtopia9593@gmail.com";

function scrollToSection(id) {
  document.getElementById(id)?.scrollIntoView({
    behavior: window.matchMedia("(pointer: coarse)").matches ? "auto" : "smooth",
    block: "start",
  });
}

const contactFieldSx = {
  "& .MuiInputLabel-root": {
    color: "rgba(255,255,255,0.72)",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#7ee8ff",
  },
  "& .MuiOutlinedInput-root": {
    color: "#ffffff",
    backgroundColor: "rgba(4, 16, 32, 0.35)",
    "& fieldset": {
      borderColor: "rgba(255,255,255,0.28)",
    },
    "&:hover fieldset": {
      borderColor: "#7ee8ff",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1976d2",
    },
  },
};

function TikTokIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M14.5 3c.4 2.4 1.8 4.1 4.1 4.4v2.5c-1.4 0-2.7-.4-3.9-1.2v6.6c0 3.4-2.7 6.2-6.2 6.2S2.3 18.7 2.3 15.3c0-3.4 2.7-6.1 6.1-6.2v2.6c-1.9.1-3.4 1.7-3.4 3.6 0 2 1.6 3.6 3.6 3.6s3.6-1.6 3.6-3.6V3h2.3z" />
    </svg>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`company-tabpanel-${index}`}
      aria-labelledby={`company-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Fade in={true} timeout={500}>
          <Box sx={{ py: 3 }}>{children}</Box>
        </Fade>
      )}
    </div>
  );
}
//tood
function HomePage() {
  const { t } = useTranslation();

  return (
    <>
        {/* Hero Section */}
        <Box
          id="home"
          sx={{
            position: "relative",
            width: "100%",
            minHeight: { xs: "100svh", md: "88vh" },
            pt: { xs: 10, md: 14 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            color: "#ffffff",
            backgroundColor: "transparent",
          }}
        >
          <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
            <Box
              sx={{
                maxWidth: { xs: "100%", md: "840px" },
                mx: "auto",
                textAlign: "center",
                px: { xs: 2, md: 0 },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: "2.2rem", sm: "2.6rem", md: "3.6rem" },
                  fontWeight: 900,
                  lineHeight: 1.15,
                  letterSpacing: "0.4px",
                  mb: { xs: 1.5, md: 2 },
                  background:
                    "linear-gradient(90deg, #ffffff 0%, #cfe8ff 35%, #90caf9 70%, #ffffff 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {t("Innovative Technology Solutions to Accelerate Your Growth")}
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  fontSize: { xs: "1rem", md: "1.2rem" },
                  color: "rgba(255,255,255,0.85)",
                  fontWeight: 500,
                  mb: { xs: 2.5, md: 3.5 },
                }}
              >
                {t(
                  "We design, build, and support modern web and mobile products — fast, reliable, and scalable.",
                )}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  justifyContent: "center",
                  flexWrap: "wrap",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    document.getElementById("services")?.scrollIntoView({
                      behavior: window.matchMedia("(pointer: coarse)").matches
                        ? "auto"
                        : "smooth",
                      block: "start",
                    })
                  }
                  sx={{
                    px: { xs: 2.5, md: 3.5 },
                    py: { xs: 1, md: 1.25 },
                    fontWeight: 700,
                    borderRadius: 2,
                    boxShadow: "0 10px 25px rgba(25,118,210,0.35)",
                  }}
                >
                  {t("Explore Services")}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() =>
                    document.getElementById("ContactUs")?.scrollIntoView({
                      behavior: window.matchMedia("(pointer: coarse)").matches
                        ? "auto"
                        : "smooth",
                      block: "start",
                    })
                  }
                  sx={{
                    px: { xs: 2.5, md: 3.5 },
                    py: { xs: 1, md: 1.25 },
                    fontWeight: 700,
                    borderRadius: 2,
                    color: "#ffffff",
                    borderColor: "rgba(255,255,255,0.6)",
                    "&:hover": {
                      borderColor: "#ffffff",
                      backgroundColor: "rgba(255,255,255,0.08)",
                    },
                  }}
                >
                  {t("Contact Us")}
                </Button>
              </Box>
            </Box>
          </Container>
          <Box sx={{ width: "100%", minWidth: 0, mt: { xs: 4, md: 6 } }}>
            <LogoSlider />
          </Box>
        </Box>
        <Page />
    </>
  );
}

function Home() {
  return (
    <Router>
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/fomsi" element={<FomsiPage />} />
          <Route path="/bardawam" element={<BardawamPage />} />
          <Route path="/uk-to-mars" element={<UkToMarsPage />} />
          <Route path="/ba-post" element={<BaPostPage />} />
          <Route path="/kts4u" element={<Kts4uPage />} />
          <Route path="/clever-school" element={<CleverSchoolPage />} />
          <Route path="/warehouse" element={<WarehousePage />} />
          <Route path="/bahoz" element={<BahozPage />} />
          <Route path="/bardawam-plus" element={<BardawamPlusPage />} />
          <Route path="/rain-season" element={<RainSeasonPage />} />
          <Route path="/talab-delivery" element={<TalabDeliveryPage />} />
          <Route path="/rebaz-cars" element={<RebazCarsPage />} />
          <Route path="/sam-home" element={<SamHomePage />} />
          <Route path="/restaurant-menu" element={<RestaurantMenuPage />} />
          <Route path="/sinolo" element={<SinoLoPage />} />
          <Route path="/noon" element={<NoonPage />} />
          <Route path="/salvano-group" element={<SalvanoGroupPage />} />
          <Route path="/karwan-company" element={<KarwanCompanyPage />} />
        </Routes>
      </div>
    </Router>
  );
}

const Page = () => {
  const [tabValue] = useState(0);
  const [contactForm, setContactForm] = useState({
    fullName: "",
    subject: "",
    phone: "",
    message: "",
  });
  const [contactStatus, setContactStatus] = useState("idle");
  const { t, i18n } = useTranslation();
  const direction = ["ku", "ar"].includes(i18n.language) ? "rtl" : "ltr";
  const textAlign = ["ku", "ar"].includes(i18n.language) ? "right" : "left";

  const handleContactChange = (field) => (event) => {
    setContactStatus((status) => (status === "sending" ? status : "idle"));
    setContactForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleContactSubmit = async (event) => {
    event.preventDefault();
    const fullName = contactForm.fullName.trim();
    const subject = contactForm.subject.trim();
    const phone = contactForm.phone.trim();
    const message = contactForm.message.trim();
    setContactStatus("sending");

    try {
      const response = await fetch(
        `https://formsubmit.co/ajax/${encodeURIComponent(CONTACT_EMAIL)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            name: fullName,
            phone,
            message,
            _subject: subject,
            _template: "table",
            _captcha: "false",
          }),
        },
      );
      const data = await response.json().catch(() => ({}));
      const needsActivation = /activat/i.test(data.message || "");

      if (!response.ok || String(data.success) !== "true") {
        setContactStatus(needsActivation ? "activation" : "error");
        return;
      }

      setContactForm({ fullName: "", subject: "", phone: "", message: "" });
      setContactStatus("success");
    } catch (error) {
      setContactStatus("error");
    }
  };

  return (
    <>
      <Container
        maxWidth="lg"
        sx={{
          py: { xs: 4, md: 8 },
          direction,
          textAlign,
        }}
      >
        {/* Company Tabs Section */}
        <section
          id="AboutUs"
          style={{ padding: "60px 0", scrollMarginTop: 96 }}
        >
          <Paper
            elevation={3}
            sx={{
              p: { xs: 3, md: 4 },
              borderRadius: 2,
              background: "transparent",
              direction,
              textAlign,
            }}
          >
            <Typography
              variant="h3"
              gutterBottom
              fontWeight={600}
              color="primary"
              align="center"
              sx={{
                fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
                mb: { xs: 4, md: 6 },
              }}
            >
              {t("Our Company")}
            </Typography>

            <TabPanel value={tabValue} index={0}>
              <Grid
                container
                spacing={{
                  xs: 2,
                  md: 4,
                }}
              >
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{
                      fontSize: { xs: "1.1rem", md: "1.5rem" },
                      color: "primary.main",
                      fontWeight: 600,
                    }}
                  >
                    {t("Who We Are")}
                  </Typography>
                  <Typography
                    variant="body1"
                    paragraph
                    sx={{
                      fontSize: { xs: "0.9rem", md: "1.1rem" },
                      lineHeight: 1.8,
                    }}
                  >
                    {t(
                      "TechTopia is a leading technology company dedicated to delivering innovative solutions that drive business growth. With over 5 years of experience, we've established ourselves as a trusted partner for businesses seeking digital transformation.",
                    )}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: "0.9rem", md: "1.1rem" },
                      lineHeight: 1.8,
                    }}
                  >
                    {t(
                      "Our team of experts combines technical excellence with creative thinking to deliver solutions that exceed expectations and create lasting value for our clients.",
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card
                    sx={{
                      height: "100%",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                      borderRadius: 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
                      },
                    }}
                  >
                    <CardContent
                      sx={{
                        p: { xs: 2, md: 3 },
                        direction,
                        textAlign,
                      }}
                    >
                      <Typography
                        variant="h6"
                        gutterBottom
                        sx={{
                          fontSize: { xs: "1rem", md: "1.25rem" },
                          color: "primary.main",
                          fontWeight: 600,
                        }}
                      >
                        {t("Our Mission")}
                      </Typography>
                      <Typography
                        variant="body1"
                        paragraph
                        sx={{ fontSize: { xs: "0.9rem", md: "1rem" } }}
                      >
                        {t(
                          "To empower businesses through innovative technology solutions that drive growth and success in the digital age.",
                        )}
                      </Typography>
                      <Typography
                        variant="h6"
                        gutterBottom
                        sx={{
                          fontSize: { xs: "1rem", md: "1.25rem" },
                          color: "primary.main",
                          fontWeight: 600,
                        }}
                      >
                        {t("Our Vision")}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontSize: { xs: "0.9rem", md: "1rem" } }}
                      >
                        {t(
                          "To be the leading technology partner for businesses seeking digital transformation and innovation.",
                        )}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </TabPanel>
          </Paper>
        </section>

        <WorkShowcase />

        {/* Services Section */}
        <section
          id="services"
          style={{
            padding: "80px 0",
            direction,
            textAlign,
            scrollMarginTop: 96,
          }}
        >
          <Box
            sx={{
              maxWidth: 1200,
              mx: "auto",
              px: { xs: 2, sm: 4 },
              direction,
              textAlign,
            }}
          >
            <Typography
              variant="h3"
              gutterBottom
              fontWeight={600}
              color="primary"
              align="center"
              sx={{
                fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
                mb: { xs: 4, md: 6 },
              }}
            >
              {t("Our Services")}
            </Typography>
            <Grid
              container
              spacing={{
                xs: 2,
                md: 4,
              }}
              justifyContent="center"
            >
              {[
                {
                  title: t("Website Development"),
                  icon: (
                    <WebOutlined sx={{ fontSize: 40, color: "primary.main" }} />
                  ),
                  details: [
                    t(
                      "Custom-designed websites that reflect your brand identity.",
                    ),
                    t(
                      "Responsive and user-friendly designs for optimal user experience.",
                    ),
                    t(
                      "Integration with CMS, e-commerce platforms, and third-party tools.",
                    ),
                  ],
                },
                {
                  title: t("Mobile App Development"),
                  icon: (
                    <PhoneAndroid
                      sx={{ fontSize: 40, color: "primary.main" }}
                    />
                  ),
                  details: [
                    t("Cross-platform applications for iOS and Android."),
                    t(
                      "Scalable and secure apps with user-friendly interfaces.",
                    ),
                    t(
                      "Expertise in integrating advanced features like geolocation, push notifications, and in-app payments.",
                    ),
                  ],
                },
                {
                  title: t("Custom Software Solutions"),
                  icon: <Code sx={{ fontSize: 40, color: "primary.main" }} />,
                  details: [
                    t(
                      "Bespoke software systems to address unique operational challenges.",
                    ),
                    t(
                      "Integration with existing systems for seamless functionality.",
                    ),
                    t("Scalable solutions to grow with your business."),
                  ],
                },
                {
                  title: t("Maintenance and Support"),
                  icon: <Build sx={{ fontSize: 40, color: "primary.main" }} />,
                  details: [
                    t("Ongoing technical support and updates."),
                    t("Performance monitoring and optimization."),
                    t("Security audits and enhancements."),
                  ],
                },
              ].map((service, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card
                    sx={{
                      height: "100%",
                      borderRadius: 3,
                      position: "relative",
                      overflow: "hidden",
                      background: "transparent",
                      boxShadow:
                        "0 10px 30px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.6)",
                      transition: "transform 0.35s ease, box-shadow 0.35s ease",
                      "&:before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: 6,
                        background:
                          "linear-gradient(90deg, #1976d2 0%, #42a5f5 50%, #90caf9 100%)",
                        opacity: 0.8,
                      },
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: "0 18px 45px rgba(0,0,0,0.12)",
                      },
                    }}
                  >
                    <CardContent
                      sx={{
                        p: { xs: 2.25, md: 3 },
                        direction,
                        textAlign,
                      }}
                    >
                      <Box
                        sx={{ mb: { xs: 1.25, md: 2 }, textAlign: "center" }}
                      >
                        {service.icon}
                      </Box>
                      <Typography
                        variant="h6"
                        fontWeight={800}
                        gutterBottom
                        align="center"
                        sx={{
                          fontSize: {
                            xs: "1.05rem",
                            sm: "1.2rem",
                            md: "1.35rem",
                          },
                          mb: { xs: 1, md: 1.25 },
                          letterSpacing: 0.2,
                        }}
                      >
                        {service.title}
                      </Typography>
                      <List
                        sx={{
                          listStyleType: "none",
                          pl: 0,
                          pr: 0,
                          textAlign,
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        {service.details.map((detail, idx) => (
                          <ListItem
                            key={idx}
                            disableGutters
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              flexDirection:
                                direction === "rtl" ? "row-reverse" : "row",
                              p: 0,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: {
                                  xs: "0.88rem",
                                  sm: "0.95rem",
                                  md: "1rem",
                                },
                                color: "text.secondary",
                                textAlign: textAlign,
                                flexGrow: 1,
                              }}
                            >
                              {detail}
                            </Typography>
                          </ListItem>
                        ))}
                      </List>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </section>

        {/* Our Approach Section */}
        <section
          id="OurApproach"
          style={{
            padding: "80px 0",
            direction,
            textAlign,
            scrollMarginTop: 96,
          }}
        >
          <Container maxWidth="lg" sx={{ direction, textAlign }}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: 3,
                background: "rgba(4, 16, 32, 0.55)",
                backdropFilter: "blur(14px)",
                border: "1px solid rgba(255,255,255,0.12)",
              }}
            >
              <Typography
                variant="h4"
                gutterBottom
                fontWeight={600}
                color="primary"
                align="center"
                sx={{
                  fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
                  mb: { xs: 4, md: 6 },
                }}
              >
                {t("Our Approach")}
              </Typography>
              <Grid
                container
                spacing={{
                  xs: 2,
                  md: 3,
                }}
              >
                {[
                  {
                    step: t("1. Understanding Your Needs"),
                    description: t(
                      "We begin by thoroughly understanding your business objectives, challenges, and goals to design a solution that perfectly aligns with your vision.",
                    ),
                  },
                  {
                    step: t("2. Design and Development"),
                    description: t(
                      "Our team works diligently to craft intuitive designs and robust systems, ensuring they meet the highest standards of functionality and usability.",
                    ),
                  },
                  {
                    step: t("3. Testing and Deployment"),
                    description: t(
                      "Rigorous testing ensures that your solution is free of errors and performs optimally. Once approved, we deploy it to your chosen platforms seamlessly.",
                    ),
                  },
                  {
                    step: t("4. Post-Deployment Support"),
                    description: t(
                      "We provide ongoing support and maintenance to ensure long-term success, making necessary updates and optimizations as your needs evolve.",
                    ),
                  },
                ].map((item, index) => (
                  <Grid item xs={12} md={6} key={index}>
                    <Box
                      sx={{
                        p: { xs: 2.25, md: 2.5 },
                        borderLeft: direction === "rtl" ? "none" : "4px solid",
                        borderRight: direction === "rtl" ? "4px solid" : "none",
                        borderColor: "primary.main",
                        bgcolor: "transparent",
                        borderRadius: 2,
                        boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        "&:hover": {
                          backgroundColor: "rgba(0,0,0,0.02)",
                          transform:
                            direction === "rtl"
                              ? "translateX(-8px)"
                              : "translateX(8px)",
                          boxShadow: "0 12px 24px rgba(0,0,0,0.08)",
                        },
                      }}
                    >
                      <Typography
                        variant="h6"
                        fontWeight={600}
                        color="primary"
                        gutterBottom
                        sx={{ fontSize: { xs: "1.1rem", md: "1.25rem" } }}
                      >
                        {item.step}
                      </Typography>
                      <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ fontSize: { xs: "0.95rem", md: "1.05rem" } }}
                      >
                        {item.description}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Paper>
          </Container>
        </section>

        {/* Why Choose Us Section */}

        <section
          id="WhyChooseUs"
          style={{
            padding: "80px 0",
            direction,
            textAlign,
            scrollMarginTop: 96,
          }}
        >
          <Typography
            variant="h3"
            gutterBottom
            fontWeight={600}
            color="primary"
            align="center"
            sx={{
              fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
              mb: { xs: 4, md: 6 },
            }}
          >
            {t("Why Choose Us?")}
          </Typography>
          <Grid
            container
            spacing={{
              xs: 2,
              md: 3,
            }}
            justifyContent="center"
            sx={{
              direction: direction,
              textAlign: textAlign,
            }}
          >
            {[
              {
                title: t("Expertise"),
                description: t(
                  "Proven track record in delivering high-quality software solutions across various industries.",
                ),
                icon: <Settings sx={{ fontSize: 35, color: "white" }} />,
              },
              {
                title: t("Customization"),
                description: t(
                  "Tailored solutions that address your unique requirements.",
                ),
                icon: <Settings sx={{ fontSize: 35, color: "white" }} />,
              },
              {
                title: t("Reliability"),
                description: t(
                  "Timely delivery and consistent post-launch support.",
                ),
                icon: <AccessAlarm sx={{ fontSize: 35, color: "white" }} />,
              },
              {
                title: t("Innovation"),
                description: t(
                  "Use of the latest technologies to ensure modern and scalable solutions.",
                ),
                icon: <Code sx={{ fontSize: 35, color: "white" }} />,
              },
              {
                title: t("Client-Centric Approach"),
                description: t(
                  "A collaborative process that prioritizes your input at every stage.",
                ),
                icon: <CheckCircle sx={{ fontSize: 35, color: "white" }} />,
              },
            ].map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    height: "100%",
                    borderRadius: 3,
                    overflow: "hidden",
                    background: "transparent",
                    boxShadow:
                      "0 10px 30px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.6)",
                    transition: "transform 0.35s ease, box-shadow 0.35s ease",
                    "&:hover": {
                      transform: "translateY(-6px)",
                      boxShadow: "0 18px 45px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <CardContent
                    sx={{
                      p: { xs: 2.25, md: 3 },
                      direction,
                      textAlign,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: { xs: 1, md: 2 },
                        flexDirection:
                          direction === "rtl" ? "row-reverse" : "row",
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: "primary.main",
                          mr: direction === "rtl" ? 0 : { xs: 1.5, md: 2 },
                          ml: direction === "rtl" ? { xs: 1.5, md: 2 } : 0,
                          width: { xs: 50, md: 60 },
                          height: { xs: 50, md: 60 },
                        }}
                      >
                        {item.icon}
                      </Avatar>
                      <Typography
                        variant="h6"
                        fontWeight={800}
                        sx={{
                          fontSize: { xs: "1.05rem", md: "1.2rem" },
                          flexGrow: 1,
                        }}
                      >
                        {item.title}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body1"
                      color="text.secondary"
                      sx={{
                        pl: direction === "rtl" ? 0 : { xs: 6.5, md: 8 },
                        pr: direction === "rtl" ? { xs: 6.5, md: 8 } : 0,
                        fontSize: { xs: "0.95rem", md: "1.05rem" },
                      }}
                    >
                      {item.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </section>

        {/* Proposed Solution Section */}
        <section
          id="ProposedSolution"
          style={{
            padding: "80px 0",
            direction: direction,
            textAlign: textAlign,
            scrollMarginTop: 96,
          }}
        >
          <Paper
            elevation={3}
            sx={{
              p: { xs: 3, md: 4 },
              borderRadius: 3,
              background: "transparent",
              boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
              direction: direction,
              textAlign: textAlign,
            }}
          >
            <Typography
              variant="h3"
              gutterBottom
              fontWeight={600}
              color="primary"
              align="center"
              sx={{
                fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
                mb: { xs: 4, md: 4 },
              }}
            >
              {t("Proposed Solution")}
            </Typography>
            <Box
              sx={{
                maxWidth: 800,
                mx: "auto",
                direction: direction,
                textAlign: textAlign,
              }}
            >
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontSize: { xs: "0.9rem", md: "1.1rem" },
                  mb: { xs: 3, md: 4 },
                  textAlign: textAlign,
                }}
              >
                {t("Based on your requirements, we propose to:")}
              </Typography>
              <List
                sx={{
                  direction: direction,
                  textAlign: textAlign,
                  pl: 0,
                  pr: 0,
                }}
              >
                {[
                  t(
                    "Create a custom website tailored specifically to your requirements and needs.",
                  ),
                  t(
                    "Focus exclusively on delivering a high-quality, bug-free solution within a short development period.",
                  ),
                  t(
                    "Incorporate features and functionalities that enhance user experience and operational efficiency.",
                  ),
                  t(
                    "Provide maintenance and support for two years post-deployment, ensuring the software operates smoothly and any potential issues are resolved promptly.",
                  ),
                ].map((item, index) => (
                  <ListItem
                    key={index}
                    disableGutters
                    sx={{
                      py: { xs: 1.5, md: 2 },
                      px: { xs: 1, md: 1.5 },
                      borderRadius: 2,
                      transition:
                        "transform 0.3s ease, background-color 0.3s ease",
                      "&:hover": {
                        backgroundColor: "rgba(0,0,0,0.02)",
                        transform:
                          direction === "rtl"
                            ? "translateX(-8px)"
                            : "translateX(8px)",
                      },
                      display: "flex",
                      alignItems: "center",
                      flexDirection:
                        direction === "rtl" ? "row-reverse" : "row",
                    }}
                  >
                    {/* <CheckCircle
                      sx={{
                        mr: direction === "rtl" ? 0 : { xs: 1.5, md: 2 },
                        ml: direction === "rtl" ? { xs: 1.5, md: 2 } : 0,
                        fontSize: { xs: 20, md: 24 },
                        color: "primary.main",
                        flexShrink: 0,
                      }}
                    /> */}
                    <ListItemText
                      primary={item}
                      primaryTypographyProps={{
                        sx: {
                          fontSize: { xs: "0.95rem", md: "1.05rem" },
                          color: "text.secondary",
                          textAlign: textAlign,
                          flexGrow: 1,
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Paper>
        </section>

        {/* Contact Us Section */}
        <section
          id="ContactUs"
          style={{
            padding: "40px 0",
            direction,
            textAlign,
            scrollMarginTop: 96,
          }}
        >
          <Container
            maxWidth="lg"
            sx={{ direction: direction, textAlign: textAlign }}
          >
            <Paper
              elevation={3}
              sx={{
                p: { xs: 3, md: 6 },
                borderRadius: 3,
                background: "transparent",
                boxShadow: "none",
                color: "#ffffff",
              }}
            >
              <Typography
                variant="h4"
                gutterBottom
                fontWeight={600}
                align="center"
                sx={{
                  mb: 4,
                  fontSize: { xs: "1.5rem", md: "2.5rem" },
                  color: "#1976d2",
                }}
              >
                {t("Get in Touch")}
              </Typography>

              <Box
                sx={{
                  maxWidth: 600,
                  mx: "auto",
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    mb: 4,
                    color: "rgba(255,255,255,0.78)",
                    fontSize: { xs: "1rem", md: "1.3rem" },
                  }}
                >
                  {t(
                    "Ready to transform your business? Let's discuss how we can help you achieve your goals.",
                  )}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: { xs: 3, md: 4 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: { xs: 1, md: 2 },
                      p: { xs: 2, md: 3 },
                      borderRadius: 2,
                      bgcolor: "rgba(4, 16, 32, 0.35)",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      transition: "transform 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                      },
                      flexDirection:
                        direction === "rtl" ? "row-reverse" : "row",
                    }}
                  >
                    <PhoneAndroid
                      sx={{ fontSize: { xs: 24, md: 32 }, color: "#1976d2" }}
                    />
                    <Box
                      sx={{
                        textAlign: direction === "rtl" ? "right" : "left",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: "rgba(255,255,255,0.78)",
                          fontSize: { xs: "0.8rem", md: "0.875rem" },
                        }}
                      >
                        {t("Call Us")}
                      </Typography>
                      <a
                        href={`tel:${t("call")}`}
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: "#1976d2",
                            fontSize: { xs: "1.15rem", md: "1.3rem" },
                          }}
                        >
                          {t("call")}
                        </Typography>
                      </a>
                    </Box>
                  </Box>
                </Box>

                <Box
                  component="form"
                  onSubmit={handleContactSubmit}
                  dir={direction}
                  sx={{
                    mt: { xs: 4, md: 5 },
                    display: "flex",
                    flexDirection: "column",
                    gap: 2.5,
                    textAlign,
                  }}
                >
                  <TextField
                    required
                    fullWidth
                    label={t("Full Name")}
                    value={contactForm.fullName}
                    onChange={handleContactChange("fullName")}
                    sx={contactFieldSx}
                  />
                  <TextField
                    required
                    fullWidth
                    label={t("Subject")}
                    value={contactForm.subject}
                    onChange={handleContactChange("subject")}
                    sx={contactFieldSx}
                  />
                  <TextField
                    required
                    fullWidth
                    type="tel"
                    label={t("Phone Number")}
                    value={contactForm.phone}
                    onChange={handleContactChange("phone")}
                    inputProps={{ dir: "ltr" }}
                    sx={contactFieldSx}
                  />
                  <TextField
                    required
                    fullWidth
                    multiline
                    minRows={4}
                    label={t("Message")}
                    value={contactForm.message}
                    onChange={handleContactChange("message")}
                    sx={contactFieldSx}
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={contactStatus === "sending"}
                    sx={{
                      alignSelf: "center",
                      minWidth: 180,
                      px: 3.5,
                      py: 1.25,
                      fontWeight: 700,
                      borderRadius: 2,
                      boxShadow: "0 10px 25px rgba(25,118,210,0.35)",
                    }}
                  >
                    {contactStatus === "sending"
                      ? t("Sending...")
                      : t("Send Message")}
                  </Button>
                  {contactStatus === "success" && (
                    <Typography sx={{ color: "#7ee8ff", textAlign: "center" }}>
                      {t("Your message was sent. We will contact you soon.")}
                    </Typography>
                  )}
                  {contactStatus === "activation" && (
                    <Typography sx={{ color: "#ffb74d", textAlign: "center" }}>
                      {t(
                        "Open techtopia9593@gmail.com and confirm the form once, then send your message again.",
                      )}
                    </Typography>
                  )}
                  {contactStatus === "error" && (
                    <Typography sx={{ color: "#ff8a80", textAlign: "center" }}>
                      {t("Could not send your message. Please try again.")}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Paper>
          </Container>
        </section>
      </Container>

      <Language />

      <Box
        component="footer"
        id="site-footer"
        className="site-footer"
        sx={{
          mt: { xs: 4, md: 6 },
          pt: { xs: 5, md: 6 },
          pb: { xs: 3, md: 4 },
          color: "#ffffff",
          background: "rgba(4, 12, 24, 0.72)",
          backdropFilter: "blur(16px)",
          borderTop: "1px solid rgba(255,255,255,0.12)",
          boxShadow: "inset 0 1px 0 rgba(126, 232, 255, 0.35)",
        }}
      >
        <Container maxWidth="lg" sx={{ direction, textAlign }}>
          <Grid container spacing={{ xs: 3, md: 4 }}>
            <Grid item xs={12} md={4}>
              <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>
                {t("TechTopia")}
              </Typography>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.78)",
                  fontSize: { xs: "0.95rem", md: "1rem" },
                  maxWidth: 360,
                }}
              >
                {t(
                  "Modern software solutions for web and mobile, delivered with quality and speed.",
                )}
              </Typography>
              <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                {[
                  {
                    label: "Facebook",
                    href: "https://www.facebook.com/techtopiaa01/",
                    icon: <Facebook />,
                  },
                  {
                    label: "Instagram",
                    href: "https://www.instagram.com/techtopia930",
                    icon: <Instagram />,
                  },
                  {
                    label: "TikTok",
                    href: "https://www.tiktok.com/@eng_baran",
                    icon: <TikTokIcon />,
                  },
                  {
                    label: "WhatsApp",
                    href: "https://wa.me/9647811421542",
                    icon: <WhatsApp />,
                  },
                ].map((social) => (
                  <IconButton
                    key={social.label}
                    component="a"
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    sx={{
                      color: "#ffffff",
                      border: "1px solid rgba(255,255,255,0.16)",
                      backgroundColor: "rgba(255,255,255,0.06)",
                      "&:hover": {
                        color: "#041018",
                        background:
                          "linear-gradient(90deg, #7ee8ff 0%, #42a5f5 100%)",
                      },
                    }}
                  >
                    {social.icon}
                  </IconButton>
                ))}
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
                {t("Quick Links")}
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {[
                  { label: t("About Us"), id: "AboutUs" },
                  { label: t("What We Have Built"), id: "WhatWeBuilt" },
                  { label: t("Services"), id: "services" },
                  { label: t("Our Approach"), id: "OurApproach" },
                  { label: t("Contact Us"), id: "ContactUs" },
                ].map((link) => (
                  <Typography
                    key={link.id}
                    component="button"
                    type="button"
                    onClick={() => scrollToSection(link.id)}
                    sx={{
                      p: 0,
                      border: 0,
                      background: "none",
                      font: "inherit",
                      textAlign: "inherit",
                      cursor: "pointer",
                      color: "rgba(255,255,255,0.78)",
                      width: "fit-content",
                      "&:hover": { color: "#7ee8ff" },
                    }}
                  >
                    {link.label}
                  </Typography>
                ))}
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
                {t("Contact")}
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Typography sx={{ color: "rgba(255,255,255,0.78)" }}>
                  {t("Phone")}: {t("call")}
                </Typography>
                <Typography sx={{ color: "rgba(255,255,255,0.78)" }}>
                  {t("Email")}:{" "}
                  <Box
                    component="a"
                    href={`mailto:${CONTACT_EMAIL}`}
                    sx={{
                      color: "inherit",
                      textDecoration: "none",
                      "&:hover": { color: "#7ee8ff" },
                    }}
                  >
                    {CONTACT_EMAIL}
                  </Box>
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Box
            sx={{
              mt: { xs: 4, md: 5 },
              pt: 2.5,
              borderTop: "1px solid rgba(255,255,255,0.1)",
              color: "rgba(255,255,255,0.6)",
              fontSize: { xs: "0.85rem", md: "0.95rem" },
              textAlign: "center",
            }}
          >
            © {new Date().getFullYear()} {t("TechTopia")} ·{" "}
            {t("All rights reserved")}
          </Box>
        </Container>
      </Box>
    </>
  );
};
export default Home;
